<template>
  <div class="back-home">
    <horizontal-nav
      class="main-nav nav"
      @navto="navto"
      bgcolor="#293042"
      :data="memuList"
    >
      <slot slot="left">
        <div class="logo flex pad-5 hover" @click="goHome">
          <img src="/static/images/nav_logo.png" alt="" />
          <div>
            <p class="fs-24">内蒙古自治区生态与农业气象中心智慧农业服务网</p>
          </div>
        </div>
      </slot>
      <slot slot="right">
        <div style="padding-right: 10px;">
          <span
            class="color-84c309 hover"
            style="margin-right: 10px;"
            @click="handleCommand(1)"
          >
            {{ showCurrentRegion }}
          </span>
          <el-dropdown>
            <span class="hover" style="color: #ffffff;">
              {{ getProfile.username }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </slot>
    </horizontal-nav>
    <!-- 区域选择对话框 -->
    <region-change-dia
      ref="rcd"
      :props="defaultProp"
      :regions="meteoRegionList"
      @changeRegion="changeRegionList"
    ></region-change-dia>
    <div style="background-color: #000;">
      <router-view />
    </div>
  </div>
</template>

<script>
import HorizontalNav from "@/components/Nav/HorizontalNav";
import BreadNav from "@/components/Nav/BreadNav";
import { switchRegionMixin } from "@/common/js/mixins";
import {
  getRegionSwitchList,
  getProductListUsable,
  putSwitchRegion,
  getMeteoStationList
} from "@/api/http";
import { region_list } from "@/config/region_cofig";
import { mapActions, mapGetters } from "vuex";
import { bradNav } from "@/Constant";
const navConfig = {
  6: "cliRegion",
  7: "agrInfo",
  8: "productWiki",
  9: "alarm",
  11: "agricultural",
  default: "agrProduct"
};
export default {
  name: "BackHome",
  mixins: [switchRegionMixin],
  components: {
    HorizontalNav,
    BreadNav
  },
  data() {
    return {
      show: false,
      memuList: [],
      meteoRegionList: [],
      defaultProp: { label: "name", children: "children", value: "code" }
    };
  },
  computed: {
    showNav() {
      return this.$route.meta.isHome;
    },
    showCurrentRegion() {
      return this.getCurrentRegion.label
        ? this.getCurrentRegion.label
        : "内蒙古自治区";
    },
    ...mapGetters(["getProfile", "getMenuOptions", "getCurrentRegion"])
  },
  created() {
    this.init();
  },
  methods: {
    async changeRegionList(region) {
      await putSwitchRegion({
        current_region: region.code
      });
      await this.setCurrentRegion();
      const { data } = await getMeteoStationList();

      sessionStorage.setItem(
        "location",
        JSON.stringify({ ...data[0], region_code: region.code })
      );
      this.reload();
    },
    async init() {
      const { data } = await getProductListUsable();
      const options = data
        .map(item => ({ ...item, order: 1 }))
        .concat(bradNav)
        .sort((a, b) => a.order - b.order);
      options.forEach(item => {
        item.name = navConfig[item.id] || navConfig.default;
      });
      await this.setMenuOptions(options);
      this.memuList = this.getMenuOptions.filter(item => !item.hiden);
      // const res = await getRegionSwitchList();
      this.meteoRegionList = region_list;
      const currentMenuItem = this.memuList.find(
        item => item.id == this.$route.query.id
      );
      if (currentMenuItem && currentMenuItem.items) {
        // items 服务产品类 + 百科 强制跳转
        this.navto(currentMenuItem);
      }
    },
    navto(item) {
      if (item.url) return (window.location = item.url);
      this.$router.push({
        name: item.name,
        query: {
          id: item.id,
          sid: item.items && item.items[0] ? item.items[0].id : 1
        }
      });
    },
    goHome() {
      this.$router.push({ name: "home" });
    },
    ...mapActions(["setMenuOptions", "setCurrentRegion"])
  }
};
</script>

<style lang="less">
.back-home {
  .nav {
    .logo {
      align-items: center;
      img {
        margin-right: 0.1rem;
      }
      span {
        color: #fff;
      }
    }
    .region {
      flex: 0 1 auto;
      .el-dropdown-link {
      }
    }
    .fs-13 {
      font-size: 0.13rem;
    }
    .fs-25 {
      font-size: 0.25rem;
    }
  }
  .main-nav.horizontal-nav nav .nav .nav-item {
    border-radius: 3px;
    color: #fff;
    &.active {
      color: #fff;
    }
    &:hover span {
      color: #fff;
    }
  }
  .second-nav {
    padding: 15px calc(50% - 640px);

    color: #838282;
    background-size: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BackHome/BackHome.vue